export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML kontrola"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte adresu a vyberte blockchain — provedeme rychlý screening."])}
}